import Header from '@/components/organisms/Header'
import { Footer } from '@/components/organisms/Footer'
import LightThemeEllipses from './LightThemeEllipses'

interface DesktopLayoutProps {
  children: React.ReactNode
}

const DesktopLayout = ({ children }: DesktopLayoutProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f2f1f6] to-[#eae9ec] dark:from-[var(--header-bg)] dark:to-[var(--header-bg)] relative flex flex-col">
      <LightThemeEllipses />
      <Header />
      
      {/* Main Content */}
      <main className="flex-1 bg-transparent relative z-10">
        {children}
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  )
}

export default DesktopLayout 
